import { useState } from "react";
import axios from "axios";

const useAddProduct = () => {
  const [formData, setFormData] = useState({
    seller_name: "",
    product_name: "",
    quantity: "",
    price: "",
    image: null,
    description: "",
    ratings: 0,
    category: "",
    unit_type: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [resetFileInput, setResetFileInput] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setError("File size exceeds 2MB limit!");
      return;
    }
    setFormData((prev) => ({ ...prev, image: file }));
    console.log("Selected file:", file);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage("");

    // Client-side validation
    if (!formData.seller_name.trim()) {
      setError("Seller Full Name is required.");
      setLoading(false);
      return;
    }
    if (!formData.product_name.trim()) {
      setError("Product Name is required.");
      setLoading(false);
      return;
    }
    if (!formData.quantity || isNaN(formData.quantity) || Number(formData.quantity) < 0) {
      setError("Quantity is required and must be a non-negative number.");
      setLoading(false);
      return;
    }
    if (!formData.price || isNaN(formData.price) || Number(formData.price) < 0) {
      setError("Price is required and must be a non-negative number.");
      setLoading(false);
      return;
    }
    if (!formData.category.trim()) {
      setError("Category is required.");
      setLoading(false);
      return;
    }
    if (!formData.unit_type.trim()) {
      setError("Unit Type is required.");
      setLoading(false);
      return;
    }
    if (!formData.description.trim()) {
      setError("Description is required.");
      setLoading(false);
      return;
    }
    if (!formData.image) {
      setError("Please upload an image.");
      setLoading(false);
      return;
    }

    // Map unit_type to is_pieces and is_kilo
    const is_kilo = formData.unit_type === "kilo" ? 1 : 0;
    const is_pieces = formData.unit_type === "pcs" ? 1 : 0;

    // Create FormData
    const formDataToSend = new FormData();
    formDataToSend.append("seller_name", formData.seller_name.trim());
    formDataToSend.append("product_name", formData.product_name.trim());
    formDataToSend.append("quantity", formData.quantity);
    formDataToSend.append("price", formData.price);
    formDataToSend.append("description", formData.description.trim());
    formDataToSend.append("ratings", formData.ratings);
    formDataToSend.append("category", formData.category.trim());
    formDataToSend.append("is_kilo", is_kilo);
    formDataToSend.append("is_pieces", is_pieces);
    formDataToSend.append("image", formData.image);

    // Debug FormData
    for (let pair of formDataToSend.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    try {
      const response = await axios.post("https://inaaniserver-50c4305cc7f7.herokuapp.com/products/add", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Response from server:", response.data);

      if (response.data.error) {
        setError(response.data.message);
      } else {
        setSuccessMessage("Product added successfully!");
        setFormData({
          seller_name: "",
          product_name: "",
          quantity: "",
          price: "",
          image: null,
          description: "",
          ratings: 0,
          category: "",
          unit_type: "",
        });
        setResetFileInput(true);
      }
    } catch (err) {
      console.error("Axios error:", err);
      setError(err.response?.data?.message || "Error adding product. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    handleChange,
    handleFileChange,
    handleSubmit,
    loading,
    error,
    successMessage,
    resetFileInput,
  };
};

export default useAddProduct;